import cn from 'clsx';
import s from './product-specs.module.css';

const SpecItem = ({ label, value }) => {
    if (!value) return null;

    return (
        <div className={s.row}>
            <dt className={cn(s.label, 'mmds-copy-three')}>{label}</dt>
            <dd className="mmds-copy-three-detail">{value}</dd>
        </div>
    );
};

export default SpecItem;
